import { lazy } from 'react'
import generateRouterDetail from 'utils/helpers/generateRouterDetail'

import { RouteAndScheduleRBAC, RouteAndScheduleUpsertRBAC } from './rbac'

const RouteAndSchedule = lazy(() => import('../pages/RouteAndSchedule'))
const RouteAndScheduleUpsert = lazy(() => import('../pages/RouteAndScheduleAddEdit'))

export const RouteAndScheduleListRouter: RouterFeatureInterface<
  'RouteAndScheduleRouter',
  '/dashboard/route'
> = {
  name: 'RouteAndScheduleRouter',
  Component: RouteAndSchedule,
  path: '/dashboard/route',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: RouteAndScheduleRBAC.pageID,
}

export const AddRouteAndScheduleRouter: RouterFeatureInterface<
  'AddRouteAndScheduleRouter',
  '/dashboard/route/add'
> = {
  name: 'AddRouteAndScheduleRouter',
  Component: RouteAndScheduleUpsert,
  path: '/dashboard/route/add',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: RouteAndScheduleUpsertRBAC.pageID,
}

export const EditRouteAndScheduleRouter: RouterFeatureInterface<
  'EditRouteAndScheduleRouter',
  '/dashboard/route/:id/edit'
> = {
  name: 'EditRouteAndScheduleRouter',
  Component: RouteAndScheduleUpsert,
  path: '/dashboard/route/:id/edit',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: RouteAndScheduleUpsertRBAC.pageID,
}

const MidmileRouter = [
  RouteAndScheduleListRouter,
  AddRouteAndScheduleRouter,
  EditRouteAndScheduleRouter,
]

export const MidmileRouterDetail = generateRouterDetail(MidmileRouter)

export default MidmileRouter
